var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.linkEnabled ? _c('router-link', _vm._g(_vm._b({
    "class": _vm.resolvedLinkClass,
    attrs: {
      "to": _vm.to
    }
  }, 'router-link', _vm.boundAttrs, false), _vm.$listeners), [_vm._t("default")], 2) : _c('span', _vm._b({
    "class": _vm.resolvedTextClass
  }, 'span', _vm.boundAttrs, false), [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }